import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Import components
import { Paragraph, Button } from 'components/elements';

// Import Icons
import { ReactComponent as TrashIcon } from 'assets/icons/ic_trash.svg';

// Import styles
import { transitionMain } from 'components/styles';

export const Wrapper = styled.div`
	position: relative;
`;

export const Box = styled.div`
	padding: 1rem 1.5rem;
	height: 8.2rem;
	display: flex;
	align-items: center;
	cursor: ${({ isLoaded, isTelevisionPage }) =>
		isTelevisionPage && !isLoaded ? 'wait' : 'pointer'};
	border-bottom: 1px solid ${({ theme }) => theme.line};
	color: ${({ theme }) => theme.grayMedium};
	${transitionMain}

	& > * {
		${transitionMain}
	}

	&:hover {
		background-color: ${({ theme: { sidebar } }) => sidebar.itemHoverBg};
		& > * {
			color: ${({ theme }) => theme.white};
		}
	}
`;

export const Preview = styled.figure`
	width: 5rem;
	margin: 0 2rem 0 0;
`;

export const Image = styled(LazyLoadImage)`
	max-height: 4rem;
	max-width: 4rem;
	object-fit: cover;
`;

export const ProductName = styled(Paragraph.Ellipsis)`
	font-weight: ${({ theme }) => theme.font.normal};
	width: 16rem;
`;

export const Content = styled.div`
	flex: 1;
	display: flex;
	justify-content: space-between;
`;

export const TrashIconStyled = styled(TrashIcon)`
	height: 2rem;
	width: 2rem;

	path {
		fill: ${({ theme: { sidebar } }) => sidebar.removeIcon};
		stroke: ${({ theme: { sidebar } }) => sidebar.removeIcon};
		${transitionMain};
	}
`;

export const ButtonStyled = styled(Button)`
	position: absolute;
	top: 3rem;
	right: 2.5rem;
	height: 2rem;
	width: 2rem;
	padding: 0;

	&:hover {
		${TrashIconStyled} {
			path {
				fill: ${({ theme: { sidebar } }) => sidebar.removeIconHover};
				stroke: ${({ theme: { sidebar } }) => sidebar.removeIconHover};
			}
		}
	}
`;
